import { render, staticRenderFns } from "./BlockViewEvent.vue?vue&type=template&id=ec4c6352&"
import script from "./BlockViewEvent.vue?vue&type=script&lang=js&"
export * from "./BlockViewEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports